import axios from 'axios';
import JSONbig from 'json-bigint';

/**
 * Axios client for login-page / forgot-password flows.
 * Does NOT use the global JWT request interceptor, so a stale access token
 * in storage cannot be attached to public auth endpoints.
 */
const publicAuthAxios = axios.create({
  timeout: 30000,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'X-Suppress-Global-Notification': 'true',
  },
  transformResponse: [
    (data) => {
      if (typeof data === 'string') {
        try {
          return JSONbig({ storeAsString: true }).parse(data);
        } catch {
          return data;
        }
      }
      return data;
    },
  ],
});

publicAuthAxios.interceptors.request.use((config: any) => {
  const headers: any = config.headers ?? {};
  const preserveAuthorization = Boolean(config.preserveAuthorization);

  if (!preserveAuthorization) {
    if (typeof headers.set === 'function') {
      headers.delete('Authorization');
      headers.delete('authorization');
    } else {
      delete headers.Authorization;
      delete headers.authorization;
    }
  }

  if (process.env.REACT_APP_GUEST_MODE === 'true') {
    if (typeof headers.set === 'function') {
      headers.set('X-Internal-Access', 'local-dev');
    } else {
      headers['X-Internal-Access'] = 'local-dev';
    }
  }

  return config;
});

export default publicAuthAxios;
